import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { TranslateService } from 'src/modules/base/services/translate.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';

@Component({
    selector: 'kx-ot-template-view',
    templateUrl: './ot-template-view.component.html',
    styleUrls: ['./ot-template-view.component.scss'],
    standalone: false
})
export class OtTemplateViewComponent implements OnInit {
  bannerData: any = {};
  config: any = {
    "submitButton": false,
    "cancelButton": false,
    "filterForm": false,
    "clearOnSave": false,
    "delegateSave": true,
    "cancelRoute": ''
  };
  formArray: any = [];
  _currentTitle: any;
  resourceDef: any;
  hideServeiceRequiest: boolean = false
  getSurgeryDropDown: any
  IsDropdownSelected:boolean = false
  defaultDropdownSettings = { singleSelection: true, checkBoxRequired: false, closeDropDownOnSelection: true, apliCall: true };

  constructor(
    private baseService: BaseService,
    private translateService: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private alerts: AlertsService,
    private loader: LoaderService,
    private changeDetect: ChangeDetectorRef

  ) { }

  ngOnInit(): void {
    this.getSurgeryDropDown = {
      datasource: {
        "resource": "surgery_request",
        "args": "encounter_id:" + this.route.snapshot.queryParams.encounter_id,
        "application": "ot",
        "key": "id",
        "query_id": "GET_SURGERY_REQUEST_BY_PATIENT"
      },
      controls: {
        surgery_request_id: {
          value: ""
        }
      },
      question: {
        defaultsetting: {
          "singleSelection": true,
          "checkBoxRequired": false,
          "closeDropDownOnSelection": true,
          "apliCall": true
        },
        "getterKey": "id",
        "getterValue": "serviceItemName",
        "format": "(item) => { const date = item.expected_surgery_date_time ? new Date(item.expected_surgery_date_time).toLocaleDateString('en-US') : ''; return `${item.serviceItemName}${date ? ' | ' + date : ''}`; }",
        "req_keys": [
          "id",
          "serviceItemName",
          "service_request_id",
          "service_order_id",
          "expected_surgery_date_time"
        ],
        key: "surgery_request_id"

      },
      defaultsetting: {
        "singleSelection": true,
        "checkBoxRequired": false,
        "closeDropDownOnSelection": true,
        "apliCall": true
      }
    }
    this.loadBannerJson()
    this.setTitle()
    this.getresourceDef()
    this.setCurrentDataType()
  }


  getresourceDef() {
    this.baseService.getResourceDef('ot_checkin_checkout_view_template', (resource) => {
      if (resource) {
        this.resourceDef = resource;
      }
    })
  }

  loadBannerJson(): void {
    const { returnUrl, key } = this.route.snapshot.queryParams;
    if (returnUrl?.includes('completed_ot')) {
      this.setBanner('ot', 'ot_surgery_details', 'GET_BY_ID', key);
      this.hideServeiceRequiest = true
    } else if (returnUrl?.includes('ot_worklist')) {
      this.setBanner('ot', 'surgery_request', 'GET_BY_ID', key);
      this.hideServeiceRequiest = true
    } else {
      this.setBanner('adt', 'encounter_ipAdmission', 'GET_BY_ID', key, 'banner_ot');
    }
  }

  setBanner(app: string, resource: string, queryId: string, key: string, jsonName: string = ''): void {
    this.bannerData = {
      ...(jsonName && { jsonName }),
      selector: 'app-patient-layout',
      datasource: {
        application: app,
        resource,
        query_id: queryId,
        args: `id:${key}`
      }
    };
  }

  setTitle(): void {
    this.translateService.translate('field.label.view_template').subscribe(x => {
      if (x) {
        this._currentTitle = x;
      }
    });
  }

  setCurrentDataType(): void {
        const currentData = JSON.parse(sessionStorage.getItem('currentData') || '{}');
        currentData['type'] = this.route.snapshot.queryParams.type;
        sessionStorage.setItem('currentData', JSON.stringify(currentData));
    }

  patientResult(event: any) {

  }

  goBack() {
    this.route.queryParams.subscribe((urlParams) => {
      this.router.navigateByUrl(urlParams.returnUrl);
    })
  }

  onSurgeryRequestSelect(event: any): void {
    const selected = event?.id;
    if (selected) {
      this.IsDropdownSelected = true
      let currentData = JSON.parse(sessionStorage.getItem('currentData') || '{}');
      currentData['surgery_request_id'] = selected;
      sessionStorage.setItem('currentData', JSON.stringify(currentData));
    }
  }

  onSurgeryRequestDeSelect(event: any): void {
    event
  }



}
